<script>
	import { slugify } from "cando-util";

	export let value;
	export let label = "text input component";
	export let tabIndex = 0;
	export let disabled = false;
	export let readonly = false;
	export let handleInputChange = () => {};
	export let cls = "input input-bordered input-primary rounded";
	export let key = "";
	export let itemId = "";
</script>

<input
	id={`${slugify(label)}-input`}
	name={`${label}`}
	type="text"
	tabindex={tabIndex}
	bind:value
	on:input={handleInputChange}
	class={cls}
	autocomplete="off"
	aria-autocomplete="none"
	{disabled}
	{readonly}
	{key}
	{itemId}
/>
